import { render, staticRenderFns } from "./amendments-list.vue?vue&type=template&id=03571af8"
import script from "./amendments-list.vue?vue&type=script&lang=js"
export * from "./amendments-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports